import React from 'react';
import '../styles/IntroSection.css';
import dubaiSkyline from '../assets/images/Intro-Image.jpg';

const IntroSection = () => {
  return (
    <section className="intro-section">
      <div className="intro-content">
        <div className="intro-text">
          <h1 className="intro-title">
            Your Gateway To Dubai's Elite Property Market
          </h1>
          <div className="intro-description">
            <p>
              At ABBASS Global Properties, we specialise in connecting international buyers with 
              premium real estate opportunities in Dubai. As part of the ABBASS Group, our expertise 
              stems from years of experience across various sectors, including property and wealth 
              creation. With a reputation for trust, transparency, and tailored solutions, our mission is to 
              make the process of purchasing property seamless and rewarding.
            </p>
            <p>
              Whether you're an investor seeking high-growth opportunities or looking to own a luxury 
              home, at ABBASS Global Properties we pride ourselves on providing you with an 
              exceptional level of information to support your decision making and ultimately help 
              acquire the perfect property for you. We are driven by a deep understanding of the 
              international real estate market and a commitment to delivering exceptional client 
              experiences.
            </p>
          </div>
        </div>
        <div className="intro-image">
          <img src={dubaiSkyline} alt="Dubai Skyline" />
        </div>
      </div>
    </section>
  );
};

export default IntroSection; 